import orderBy from "lodash/orderBy";

import {getCurrentRoomType} from "../appLayout";
import {LOOK_ROOM_TYPES} from "../look/core/constants";

export const getLayerPartToRender = (layerHovering, hoveredLayerIndex, layers) => {
  return {
    zIndex: layers[hoveredLayerIndex].zIndex,
    cropCoords: layers[hoveredLayerIndex].cropCoords,
    coords: layers[hoveredLayerIndex].coords,
    image: layerHovering.greenImage,
    layerDimensions: layerHovering.layerDimensions,
    partId: layerHovering.layer.partId || "",
    isGreenHovering: true,
    hoveringImage: layerHovering.hoveringImage,
  }
}

export const checkForLayerParts = (imageCanvasComponent, layers, hoveredLayerIndex, layerHovering, allLayers) => {
  // 1) add new Green Layer
  layers.splice(hoveredLayerIndex + 1, 0, getLayerPartToRender(layerHovering, hoveredLayerIndex, layers));

  // 2) Check if it needs additional Part
  // console.log("layerHovering", layerHovering);
  // console.log("layersHoverings", layersHoverings);
  switch (document.kvConfig.visualizerType) {
    case "Bathroom":
    case "BV": {
      const ShowerBodyIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].Shower.Steam60in.Body;
      const ShowerIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].Shower.Custom60in;
      if (layerHovering.layer.zIndex === ShowerBodyIndexes["1"] || layerHovering.layer.zIndex === ShowerBodyIndexes["2"]) {

        const missingBodyPart = layerHovering.layer.zIndex === ShowerBodyIndexes["1"] ? "2" : "1";

        const layerHovering2 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === ShowerBodyIndexes[missingBodyPart]
        });
        const hoveredLayerIndex = layers.findIndex((layer) => {
          return layer.zIndex === layerHovering2.layer.zIndex
        });

        layers.splice(hoveredLayerIndex + 1, 0, {
          zIndex: ShowerBodyIndexes[missingBodyPart],
          image: layerHovering2.greenImage,
          layerDimensions: layerHovering2.layerDimensions,
          isGreenHovering: true,
          hoveringImage: layerHovering2.hoveringImage,
        });
      }
      if (layerHovering.layer.zIndex === ShowerIndexes.Wall || layerHovering.layer.zIndex === ShowerIndexes.Wall2
        || layerHovering.layer.zIndex === ShowerIndexes.WallAccent || layerHovering.layer.zIndex === ShowerIndexes.WallAccent2) {
        let missingZIndex = 0;
        if (layerHovering.layer.zIndex === ShowerIndexes.Wall || layerHovering.layer.zIndex === ShowerIndexes.Wall2) {
          missingZIndex = layerHovering.layer.zIndex === ShowerIndexes.Wall ? ShowerIndexes.Wall2 : ShowerIndexes.Wall;
        }
        if (layerHovering.layer.zIndex === ShowerIndexes.WallAccent || layerHovering.layer.zIndex === ShowerIndexes.WallAccent2) {
          missingZIndex = layerHovering.layer.zIndex === ShowerIndexes.WallAccent ? ShowerIndexes.WallAccent2 : ShowerIndexes.WallAccent;
        }
        const layerHovering2 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZIndex
        });
        if (layerHovering2) {
          const hoveredLayerIndex = layers.findIndex((layer) => {
            return layer.zIndex === layerHovering2.layer.zIndex
          });
          layers.splice(hoveredLayerIndex + 1, 0, {
            zIndex: missingZIndex,
            image: layerHovering2.greenImage,
            layerDimensions: layerHovering2.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering2.hoveringImage,
          });
        }
      }
      break;
    }
    case "bvScene": {
      // const CabinetIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].Cabinet;
      let missingZindex = 0;
      let missingZindex2 = 0;
      // switch(layerHovering.layer.zIndex) {
      //   case CabinetIndexes["CrownMolding"]:
      //     missingZindex = CabinetIndexes["CrownMolding2"];
      //     break;
      // }
      if (missingZindex) {
        const layerHovering2 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZindex
        });
        const hoveredLayerIndex2 = layers.findIndex((layer) => {
          return layer.zIndex === missingZindex
        });
        if (layerHovering2 && hoveredLayerIndex2) {
          layers.splice(hoveredLayerIndex2 + 1, 0, {
            zIndex: missingZindex,
            image: layerHovering2.greenImage,
            layerDimensions: layerHovering2.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering2.hoveringImage,
          });
        }
      }
      if (missingZindex2) {
        const layerHovering3 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZindex2
        });
        const hoveredLayerIndex3 = layers.findIndex((layer) => {
          return layer.zIndex === missingZindex2
        });
        if (layerHovering3 && hoveredLayerIndex3) {
          layers.splice(hoveredLayerIndex3 + 1, 0, {
            zIndex: missingZindex2,
            image: layerHovering3.greenImage,
            layerDimensions: layerHovering3.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering3.hoveringImage,
          });
        }
      }
      break;
    }
    case "Kitchen": {
      const CabinetIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].Cabinet;
      const CountertopGroupIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].CountertopGroup;
      let missingZindex = 0;
      let missingZindex2 = 0;
      switch(layerHovering.layer.zIndex) {
        case CabinetIndexes["TopCabinet"]:
          missingZindex = CabinetIndexes["TopCabinet2"];
          break;
        case CabinetIndexes["TopCabinet2"]:
          missingZindex = CabinetIndexes["TopCabinet"];
          break;
        case CabinetIndexes["BottomCabinet"]:
          missingZindex = CabinetIndexes["BottomCabinet2"];
          missingZindex2 = CabinetIndexes["Peninsula"];
          break;
        case CabinetIndexes["BottomCabinet2"]:
          missingZindex = CabinetIndexes["BottomCabinet"];
          missingZindex2 = CabinetIndexes["Peninsula"];
          break;
        case CabinetIndexes["Peninsula"]:
          missingZindex = CabinetIndexes["BottomCabinet"];
          missingZindex2 = CabinetIndexes["BottomCabinet2"];
          break;
        case CabinetIndexes["CrownMolding"]:
          missingZindex = CabinetIndexes["CrownMolding2"];
          break;
        case CabinetIndexes["CrownMolding2"]:
          missingZindex = CabinetIndexes["CrownMolding"];
          break;
        case CountertopGroupIndexes["Countertop"]:
          missingZindex = CountertopGroupIndexes["Countertop2"];
          break;
        case CountertopGroupIndexes["Countertop2"]:
          missingZindex = CountertopGroupIndexes["Countertop"];
          break;
        case CabinetIndexes["TopHandle"]:
          missingZindex = CabinetIndexes["TopHandle2"];
          break;
        case CabinetIndexes["TopHandle2"]:
          missingZindex = CabinetIndexes["TopHandle"];
          break;
        case CabinetIndexes["BottomHandle"]:
          missingZindex = CabinetIndexes["BottomHandle2"];
          break;
        case CabinetIndexes["BottomHandle2"]:
          missingZindex = CabinetIndexes["BottomHandle"];
          break;
      }
      if (missingZindex) {
        const layerHovering2 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZindex
        });
        const hoveredLayerIndex2 = layers.findIndex((layer) => {
          return layer.zIndex === missingZindex
        });
        if (layerHovering2 && hoveredLayerIndex2) {
          layers.splice(hoveredLayerIndex2 + 1, 0, {
            zIndex: missingZindex,
            image: layerHovering2.greenImage,
            layerDimensions: layerHovering2.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering2.hoveringImage,
          });
        }
      }
      if (missingZindex2) {
        const layerHovering3 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZindex2
        });
        const hoveredLayerIndex3 = layers.findIndex((layer) => {
          return layer.zIndex === missingZindex2
        });
        if (layerHovering3 && hoveredLayerIndex3) {
          layers.splice(hoveredLayerIndex3 + 1, 0, {
            zIndex: missingZindex2,
            image: layerHovering3.greenImage,
            layerDimensions: layerHovering3.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering3.hoveringImage,
          });
        }
      }
      break;
    }
    case "kvMaster": {
      // 2) Check if it needs additional Part
      const CabinetIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].Cabinet;
      const CountertopGroupIndexes = imageCanvasComponent.props.layout.zIndexes[imageCanvasComponent.props.layoutType].CountertopGroup;
      let missingZindex = 0;
      let missingZindex2 = 0;
      switch(layerHovering.layer.zIndex) {
        case CabinetIndexes["TopCabinet"]:
          missingZindex = CabinetIndexes["TopCabinet2"];
          break;
        case CabinetIndexes["TopCabinet2"]:
          missingZindex = CabinetIndexes["TopCabinet"];
          break;
        case CabinetIndexes["BottomCabinet"]:
          missingZindex = CabinetIndexes["BottomCabinet2"];
          missingZindex2 = CabinetIndexes["Peninsula"];
          break;
        case CabinetIndexes["BottomCabinet2"]:
          missingZindex = CabinetIndexes["BottomCabinet"];
          missingZindex2 = CabinetIndexes["Peninsula"];
          break;
        case CabinetIndexes["Peninsula"]:
          missingZindex = CabinetIndexes["BottomCabinet"];
          missingZindex2 = CabinetIndexes["BottomCabinet2"];
          break;
        case CabinetIndexes["CrownMolding"]:
          missingZindex = CabinetIndexes["CrownMolding2"];
          break;
        case CabinetIndexes["CrownMolding2"]:
          missingZindex = CabinetIndexes["CrownMolding"];
          break;
        case CountertopGroupIndexes["Countertop"]:
          missingZindex = CountertopGroupIndexes["Countertop2"];
          break;
        case CountertopGroupIndexes["Countertop2"]:
          missingZindex = CountertopGroupIndexes["Countertop"];
          break;
        case CabinetIndexes["TopHandle"]:
          missingZindex = CabinetIndexes["TopHandle2"];
          break;
        case CabinetIndexes["TopHandle2"]:
          missingZindex = CabinetIndexes["TopHandle"];
          break;
        case CabinetIndexes["BottomHandle"]:
          missingZindex = CabinetIndexes["BottomHandle2"];
          break;
        case CabinetIndexes["BottomHandle2"]:
          missingZindex = CabinetIndexes["BottomHandle"];
          break;
      }
      if (missingZindex) {
        const layerHovering2 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZindex
        });
        const hoveredLayerIndex2 = layers.findIndex((layer) => {
          return layer.zIndex === missingZindex
        });
        if (layerHovering2 && hoveredLayerIndex2) {
          layers.splice(hoveredLayerIndex2 + 1, 0, {
            zIndex: missingZindex,
            image: layerHovering2.greenImage,
            layerDimensions: layerHovering2.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering2.hoveringImage,
          });
        }
      }
      if (missingZindex2) {
        const layerHovering3 = imageCanvasComponent.state.layersHoverings.find((layersHoveringItem) => {
          return layersHoveringItem.layer.zIndex === missingZindex2
        });
        const hoveredLayerIndex3 = layers.findIndex((layer) => {
          return layer.zIndex === missingZindex2
        });
        if (layerHovering3 && hoveredLayerIndex3) {
          layers.splice(hoveredLayerIndex3 + 1, 0, {
            zIndex: missingZindex2,
            image: layerHovering3.greenImage,
            layerDimensions: layerHovering3.layerDimensions,
            isGreenHovering: true,
            hoveringImage: layerHovering3.hoveringImage,
          });
        }
      }
      break;
    }
    case "kvScene":
    case "bvLook":
    case "LaundryRoom":
    case "Laundryroom":
    case "laundryroom":
    case "laundryRoom": {
      let needToCheck = false;
      if (document.kvConfig.visualizerType === "kvScene") {
        const withParts = ["countertop", "top_cabinet", "bottom_cabinet", "handle", "crown_molding",
          "top_handle", "bottom_handle", "door_handle", "drawer_handle"];
        needToCheck = withParts.includes(layerHovering.layer.partId);
      } else if (document.kvConfig.visualizerType === "bvLook") {
        needToCheck = getCurrentRoomType() === LOOK_ROOM_TYPES.as && layerHovering.layer.partId.includes("vanity_");
      } else {
        const withParts = ["slat_wall", "bottom_cabinet", "tall_cabinet"];
        needToCheck = withParts.includes(layerHovering.layer.partId);
      }
      if (!needToCheck && !allLayers) {
        break;
      }
      imageCanvasComponent.state.layersHoverings.forEach(layerHov => {
        if (layerHov.layer.partId === layerHovering.layer.partId && (layerHov.layer.zIndex !== layerHovering.layer.zIndex)) {
          layers.push({
            zIndex: layerHov.layer.zIndex,
            cropCoords: layerHov.layer.cropCoords,
            image: layerHov.greenImage,
            layerDimensions: layerHov.layerDimensions,
            coords: layerHov.layer.coords || null,
            partId: layerHov.layer.partId || "",
            isGreenHovering: true,
            hoveringImage: layerHov.hoveringImage,
          });
        }
      });
      return orderBy(layers, ['zIndex'], ['desc']);
    }
    default:
      break;
  }

  return layers;
};
